import { all, fork } from 'redux-saga/effects';
import { homePageSaga } from '@components/HomePage';

import { carQuotePageSaga } from '@components/CarQuotePage';
import { carQuoteResultPageSaga } from '@components/CarQuoteResultPage';
import { carQuoteComparePageSaga } from '@components/CarQuoteComparePage';
import { carQuoteDetailsRouteSaga } from '@components/CarQuoteDetailsRoute';
import { carQuoteBuyRouteSaga } from '@components/CarQuoteBuyRoute';
import { CarQuotePaymentPageSaga } from '@components/CarQuotePaymentPage';

import { healthQuoteResultPageSaga } from '@components/HealthQuoteResultPage';
import { healthQuoteComparePageSaga } from '@components/HealthQuoteComparePage';
import { healthQuoteDetailsRouteSaga } from '@components/HealthQuoteDetailsRoute';
import { healthQuoteBuyRouteSaga } from '@components/HealthQuoteBuyRoute';
import { healthQuotePaymentPageSaga } from '@components/HealthQuotePaymentPage';

import { corporateHealthQuoteBuyRouteSaga } from '@components/CorporateHealthQuoteBuyRoute';

import { personalAccidentQuoteResultPageSaga } from '@components/PersonalAccidentQuoteResultPage';
import { personalAccidentQuoteDetailsPageSaga } from '@components/PersonalAccidentQuoteDetailsRoute';
import { personalAccidentQuoteBuyRouteSaga } from '@components/PersonalAccidentQuoteBuyRoute';
import { personalAccidentQuotePaymentPageSaga } from '@components/PersonalAccidentQuotePaymentPage';
import { personalAccidentQuoteComparePageSaga } from '@components/PersonalAccidentQuoteComparePage';

import { cancerQuoteResultPageSaga } from '@components/CancerQuoteResultPage';
import { cancerQuoteDetailsRouteSaga } from '@components/CancerQuoteDetailsRoute';
import { cancerQuoteBuyRouteSaga } from '@components/CancerQuoteBuyRoute';
import { cancerQuotePaymentPageSaga } from '@components/CancerQuotePaymentPage';
import { cancerQuoteComparePageSaga } from '@components/CancerQuoteComparePage';

import { generalQuoteBuyRouteSaga } from '@components/GeneralQuoteBuyRoute';
import { generalOrderPaymentPageSaga } from '@components/GeneralOrderPaymentPage';

import { insurancePolicyBuyRouteSaga } from '@components/InsurancePolicyBuyRoute';

import { userRegistrationSaga } from '@components/UserRegistration';
import { userDashboardRouteSaga } from '@components/UserDashboardRoute';
import { authSaga } from '@components/Auth';
import { abaPaywaySaga } from '@components/AbaPayway';
import { camDxSaga } from '@components/CamDxPage';
import { articlePageSaga } from '@components/ArticlePage';
import { articleDetailsPageSaga } from '@components/ArticleDetailsPage';
import { photoManagerDialogSaga } from '@components/PhotoManagerDialog';
import { fakePaymentSaga } from '@components/FakePayment';
import { occupationSaga } from '@components/Occupation';
import { userLeadSaga } from '@components/UserLead';
import { corporateLeadSaga } from '@components/CorporateLead';
import { hospitalNetworkPageSaga } from '@components/HospitalNetworkPage';
import { garageNetworkPageSaga } from '@components/GarageNetworkPage';

import { featureCarSaga } from '@components/Feature/Car';
import { featureSaga } from '@components/Feature';

export default function* () {
  yield all([
    fork(homePageSaga),
    fork(featureSaga),

    fork(carQuotePageSaga),
    fork(carQuoteResultPageSaga),
    fork(carQuoteComparePageSaga),
    fork(carQuoteDetailsRouteSaga),
    fork(userRegistrationSaga),
    fork(carQuoteBuyRouteSaga),
    fork(CarQuotePaymentPageSaga),

    fork(healthQuoteResultPageSaga),
    fork(healthQuoteComparePageSaga),
    fork(healthQuoteDetailsRouteSaga),
    fork(healthQuoteBuyRouteSaga),
    fork(healthQuotePaymentPageSaga),

    fork(corporateHealthQuoteBuyRouteSaga),

    fork(personalAccidentQuoteResultPageSaga),
    fork(personalAccidentQuoteDetailsPageSaga),
    fork(personalAccidentQuoteBuyRouteSaga),
    fork(personalAccidentQuotePaymentPageSaga),
    fork(personalAccidentQuoteComparePageSaga),

    fork(cancerQuoteResultPageSaga),
    fork(cancerQuoteDetailsRouteSaga),
    fork(cancerQuoteBuyRouteSaga),
    fork(cancerQuotePaymentPageSaga),
    fork(cancerQuoteComparePageSaga),

    fork(generalQuoteBuyRouteSaga),
    fork(generalOrderPaymentPageSaga),

    fork(insurancePolicyBuyRouteSaga),

    fork(userDashboardRouteSaga),
    fork(authSaga),
    fork(abaPaywaySaga),
    fork(camDxSaga),
    fork(articlePageSaga),
    fork(articleDetailsPageSaga),
    fork(photoManagerDialogSaga),
    fork(fakePaymentSaga),
    fork(occupationSaga),
    fork(userLeadSaga),
    fork(corporateLeadSaga),
    fork(hospitalNetworkPageSaga),
    fork(garageNetworkPageSaga),

    fork(featureCarSaga),
  ]);
}
